export const nav = {
  home: "首页",
  about: "走进老舍",
  news: "茶馆新闻",
  onlineBooking: "在线订票",
  manage: "经营特色",
  stores: "茶馆分店",
  contactUs: "联系我们",
};
export const index_2 = {
  title: "北京老舍茶馆",
  content:
    "始建于1988年，其前身可追溯到1979年的前门大碗茶。老舍茶馆位于天安门广场西南面，与北京古商业街大栅栏为邻，地理位置独特，文化底蕴深厚。\n老舍茶馆以“振兴古国茶文化，扶植民族艺术花”为经营宗旨，现营业面积5000多平方米，是集京味茶文化、戏曲文化、餐饮文化等于一身，融书茶馆、餐茶馆、清茶馆、大茶馆、野茶馆、清音桌等六大老北京传统茶馆形式于一体的京味茶馆文化集萃地，包含茶事服务、文化演出、特色餐饮和茶礼品四大经营业态。店内开设有京味茶文化产品服务体验售卖区、艺苑、四合茶院、品珍楼、演出大厅等经营场所，另有老二分大碗茶摊、戏迷乐京剧票房和老北京传统商业博物馆三大公益项目。\n自开业以来，老舍茶馆共接待了包括美国前总统布什、前国务卿基辛格，俄罗斯前总理普里马科夫，德国前总理科尔等来自80个国家的180多位外国元首政要，众多社会名流和700多万中外游客，拥有全国16家连锁店，被誉为展示民族文化精品的 “窗口”和联结中外人民友谊的“桥梁”;有着“北京城市名片”和“京味人文地标”的美誉;先后被评为国家文化产业示范基地、国家3A级旅游景区(点)、全国文明单位、全国百佳茶馆之首和北京市著名商标。",
};
export const index_5 = {
  teaHouseNews: {
    tab: "茶馆新闻",
    title: [
      "科学防控,筑牢健康防线 老舍茶馆做好冬季服务保障工作",
      "演出预告‖2021年元旦小短假老舍茶馆演出观看指南",
      "新品上市‖2021年老舍茶馆生肖茶 牛转乾坤 扫码购买",
    ],
    content: [
      "管理措施科学，精准防控到位，在北京疫情有所反复的情况下，老舍茶馆员工牢固树立‘时时防、处处防’的理念，坚持“全覆盖、无死角、无盲区、无空白”原则，严格落实环境消毒消杀防疫要求，疫情防控措施到位，采用科学手段严控客流，为元旦假期游客的游览提供安全保障。",
      "不知不觉，2021年即将来临，老舍茶馆在元旦期间，将为广大观众奉献经典演出，快看看节目安排吧！",
      "老舍茶馆牛年生肖饼《封神演义》中五色神牛主管人间吉凶祸福东岳泰山天齐仁圣大帝黄飞虎的坐骑五色神牛力大无尽，不惧凶兽，可托云行走，趋吉辟邪。祝愿茶友们能够牛气冲天。",
    ],
  },
  partyBuildingNews: {
    tab: "党建新闻",
    title: [
      "中联部礼宾局副局长张露率队到大碗茶公司交流党建工作",
      "茶香飘两会 情暖值守人 李婕书记为大碗茶老舍茶馆送锦旗和...",
      "大碗茶公司召开党支部书记述职评议会议",
    ],
    content: [
      "应北京市大碗茶文化发展有限公司党支部之邀，2019年5月24日上午，中联部礼宾局副局长张露率中联部礼宾局一处党小组一行8人到大碗茶公司老舍茶馆交流党建工作。大碗茶公司党支部支委、高层管理人员、公司党员和入党积极分子参加座谈。活动由大碗茶公司党办主任顾德茂主持。活动伊始，张...",
      "2019年4月19日上午，西城区委大栅栏街道工委书记李婕，副书记吴建华、范鹏一行来到大碗茶老舍茶馆赠送锦旗“茶香飘两会情暖值守人”和慰问品，代表大栅栏街道工委对大碗茶老舍茶馆在2019全国“两会”期间为大栅栏地区执勤点志愿者义务送水表示感谢。李婕书记在讲话中说，2019全国“两会...",
      "2019年3月5日上午，大碗茶公司党支部书记述职评议会议在四层会议室召开，西城区国资委党建科科长苏郁颖、干部李向阳，北京市大碗茶文化发展有限公司党支部书记、董事长、总经理尹智君出席，公司领导班子全体成员、党员、入党积极分子、中高层管理人员和基层员工代表参加会议。会议由大...",
    ],
  },
  headOfState: {
    tab: "百名元首",
    title: "“一带一路”贵宾 老挝人革党中央政治局委员坎潘•蓬玛塔莅...",
    content:
      "10月10日晚，布基纳法索争取进步人民运动党代理主席西蒙·孔波雷一行做客老舍茶馆品特色美食、欣赏京味儿演出、领略中国文化。“来了您呐，里边请……”步入老舍茶馆，西蒙·孔波雷主席即被浓郁的京味儿文化元素所吸引，并在大碗茶琴前驻足。在聆听了一整首中国民歌《茉莉花》后...",
  },
  publicWlfareActivities: {
    tab: "公益活动",
    title: "西城区人大代表 大碗茶公司党支部书记尹智君慰问社区困难...",
    content:
      "2019年1月31日下午，新春慰问困难户，浓浓关怀暖人心。己亥猪年春节将至，西城区人大代表、北京市大碗茶文化发展有限公司党支部书记、董事长、总经理，北京老舍茶馆有限公司董事长、总经理尹智君与大栅栏街道人大办主任孔祥博、前西社区服务站站长张葳一起到前西社区困难党员群众家庭走访...",
  },
  teaParty: {
    tab: "小饮茶会",
    title: [
      "回顾「小饮茶会第229期」小饮茶会之名家内画鼻烟壶赏析",
      "回顾「小饮茶会第228期」小饮茶会之为您讲授冬月高效能读书心法",
    ],
    content: [
      "壶里看乾坤，方寸有意境。近日，由北京市文物公司策划的“凝烟撷萃——北京市文物公司藏内画鼻烟壶”展览在琉璃厂虹光阁开幕。展览展出了包括“京派内画四大家”在内的百余件清末民国时期的内画鼻烟壶名家大师作品。2019年1月11日，老舍茶馆小饮茶会带领茶友们走进北京市文物公司虹光...",
      "书中自有黄金屋，书中自有颜如玉。读书的好处是说不尽的，但读书需要有正确的方法。2019年1月4日，小饮茶会邀请北京重点中学优秀教师、冬月高效能阅读心法创始人王冬月老师与大家分享“冬月高效能读书心法”。北京老舍茶馆有限公司常务副总经理唐波与十余位茶友参加。",
    ],
  },
};

export const index_6 = {
  title: [
    "北京前门总店",
    "北京大屯店",
    "北京西单觅食森林店",
    "北京延庆世园会店",
    "山东青岛海龙路店",
    "山东泰安国际金融中心店",
    "山东济南汉峪金谷店",
    "湖北武昌万达公馆店",
    "湖北武昌万达御湖世家店",
    "安徽蚌埠龙子湖店",
    "陕西西安西咸新区诗经里店",
    "湖南长沙黄花国际机场T2航站楼店",
    "河南开封960创意园区店",
    "浙江义乌绣湖里店",
    "北京大兴国际机场航站楼S-AR05-001店",
    "山东威海方邻·海汇mall店（即将开业）",
  ],
  content: [
    "北京前门总店 电话：010-63036830",
    "北京大屯店 电话：010-84874186",
    "北京西单觅食森林店 电话：13651365276",
    "",
    "山东青岛海龙路店 电话：0532-88979588",
    "山东泰安国际金融中心店 电话：0538-58811707（品茗） 708（就餐）",
    "山东济南汉峪金谷店 电话：0513-55585196",
    "湖北武昌万达公馆店 电话：027-88111118",
    "湖北武昌万达御湖世家店 电话：027-87116686",
    "安徽蚌埠龙子湖店 电话：0522-3736000",
    "陕西西安西咸新区诗经里店 电话：029-89599859/89599459",
    "湖南长沙黄花国际机场T2航站楼店 电话：13975855413",
    "河南开封960创意园区店 电话：0371-23339678/23331678",
    "浙江义乌绣湖里店 电话：0579-81552876",
    "",
    "",
  ],
};

export const index_7 = {
  title: ["北京老舍茶馆有限公司", "官方微信", "在线购票"],
  content: {
    address: "总店地址:北京是西城区前门西大街正阳市场三号楼",
    phone: "电话:010-63036830",
    website: "网址:www.laosheteahouse.com",
  },
  bottom: [
    "版权所有 © 北京老舍茶馆有限公司",
    "京公网安备11010202007155号",
    "京ICP备13013214号-2",
    "工商备案公示信息",
  ],
};

export const article = {
  title: ["茶馆介绍", "茶馆历史", "企业形象宣传片", "创始人介绍"],
  content: {
    teahouse: [
      "北京老舍茶馆始建于1988年，是中国改革开放以后北京第一家民俗文化茶馆。其前身为1979年前门箭楼西侧两分钱一碗的大碗茶摊。老舍茶馆位于天安门广场西南面，与北京古商业街大栅栏为邻，地理位置独特，文化底蕴深厚。\n\n",
      "老舍茶馆以“振兴古国茶文化，扶植民族艺术花”为经营宗旨，现营业面积5000多平方米，是集京味茶文化、戏曲文化、餐饮文化等于一身，融书茶馆、餐茶馆、清茶馆、大茶馆、野茶馆、清音桌等六大老北京传统茶馆形式于一体的京味茶馆文化集萃地，包含茶事服务、文化演出、特色餐饮和茶礼品四大经营业态。店内开设有京味茶文化产品服务体验售卖区、艺苑、非遗体验厅、四合茶院、品珍楼、演出大厅六大经营场所，另有老二分大碗茶摊、戏迷乐京剧票房和老北京传统商业博物馆三大公益项目。\n\n",
      "自开业以来，老舍茶馆共接待了包括美国前总统布什、前国务卿基辛格，俄罗斯前总理普里马科夫，德国前总理科尔等来自80个国家的190多位外国元首政要，众多社会名流和700多万中外游客，拥有全国16家连锁店，被誉为展示民族文化精品的“窗口”和联结中外人民友谊的“桥梁”;有着“北京城市名片”和“京味人文地标”的美誉;先后被评为国家文化产业示范基地、国家3A级旅游景区(点)、全国文明单位、全国百佳茶馆之首和北京市著名商标。",
    ],
    history: [
      "1979年，为响应党的改革开放政策，大碗茶老舍茶馆创始人尹盛喜先生带领返城知青，白手起家，在北京前门地区售卖二分钱一碗的大碗茶。\n",
      "1988年，大碗茶公司举全部之力投资创办我国改革开放后的第一家文化茶馆——北京老舍茶馆。\n",
      "老舍茶馆创办至今，累计接待有来自80多个国家的190多位外国元首政要和700多万中外宾客，是展示民族文化精品的“窗口”和联结中外人民友谊的“桥梁”，有“北京城市金名片”、“民间外交平台”和“京味儿文化地标”的美誉。\n",
      "如今，老舍茶馆已涵盖茶、戏、餐、礼四大经营业态，举办了230余场面向80、90后年轻人的小饮茶会，推广传统文化。\n",
      "40多载时间里，我们在发展中不断摸索，聚焦北京的城市功能定位，打造“国家茶馆”、“外交茶馆”、“科技教育茶馆”和“百姓茶馆”，为满足人民群众美好生活需要服务。",
    ],
    video: "",
    founder: [
      "\n尹盛喜简介：\n\n",
      "尹盛喜，1938年——2003年。中共党员，大专学历。生前荣获全国五一劳动奖章、北京市劳动模范等荣誉；北京市第八届、九届人大代表，北京市宣武区第十二届人大代表。\n\n",
      "1964——1964——1978年任北京大栅栏街道办事处干部\n\n",
      "1979年任北京大栅栏贸易公司经理\n\n",
      "1988年——2003年任北京大碗茶商贸集团公司总经理兼老舍茶馆总经理。\n",
      "\n主要成就：\n\n",
      "1979年党的十一届三中全会拉开改革开放的序幕，此时身为北京市宣武区大栅栏街道办事处干部的尹盛喜同志，积极响应党的“安置待业青年，发展集体经济”号召，主动“为国分忧、为民解难”，组织街道待业知青，白手起家，自谋出路。1979年6月，在前门箭楼西侧摆起“二分钱”茶摊，成立大碗茶青年茶社。其与安徽凤阳小岗村、深圳蛇口特区一起被誉为改革开放初期贯彻党在社会主义初级阶段基本路线的三个标志性事件。\n\n",
      "1983年9月创办震云阁工艺品深圳公司。从洽谈联营到公司开业，只用了4个月的时间。这种速度在当时的深圳也是超前的。该公司的建立开创了北京集体企业在深圳设立窗口的先河。\n\n",
      "1988年12月15日创建“老舍茶馆”。运用“老舍茶馆”平台弘扬民族艺术，为京剧、曲艺演员增加一个施展才能的场所，丰富人民群众的文化生活，加强祖国的精神文明建设。",
    ],
  },
};

export const news = {
  teaHouseNews: {
    tab: "茶馆新闻",
    title: [
      "科学防控,筑牢健康防线 老舍茶馆做好冬季服务保障工作",
      "演出预告‖2021年元旦小短假老舍茶馆演出观看指南",
      "新品上市‖2021年老舍茶馆生肖茶 牛转乾坤 扫码购买",
      "知时节 | 小暑：夏日消暑大作战",
      "前门总店 | 暑期倾情奉献，传奇正在上演 — 儿童剧《八臂哪咤城》",
      "国家文化产业示范基地——老舍茶馆落户开封暨老舍茶馆开封店首届...",
    ],
    content: [
      "管理措施科学，精准防控到位，在北京疫情有所反复的情况下，老舍茶馆员工牢固树立‘时时防、处处防’的理念，坚持“全覆盖、无死角、无盲区、无空白”原则，严格落实环境消毒消杀防疫要求，疫情防控措施到位，采用科学手段严控客流，为元旦假期游客的游览提供安全保障。",
      "不知不觉，2021年即将来临，老舍茶馆在元旦期间，将为广大观众奉献经典演出，快看看节目安排吧！",
      "老舍茶馆牛年生肖饼《封神演义》中五色神牛主管人间吉凶祸福东岳泰山天齐仁圣大帝黄飞虎的坐骑五色神牛力大无尽，不惧凶兽，可托云行走，趋吉辟邪。祝愿茶友们能够牛气冲天。",
      "倏忽温风至，因循小暑来小暑，六月节，是夏天的第五个节气，表示季夏时节的正式开始。虽说还没到最热，但是“小暑过，一日热三分”。炎炎夏日，即将开启蒸煮模式，老舍茶馆为您解锁避暑妙招。小暑品茶小暑，在室外喷火的天气里，品一杯寿眉白茶，味温性凉，有健胃提神之效，祛湿退热之功。衬托小暑的节气，...",
      "故事源于老北京的民间传说和你我的日常生活，通过展现亘古不变的亲情友情和瞬息万变的都市人情，最终实现城市与人共同的成长。演出将京味文化与魔幻现实主义结合，多样的舞台呈现让人耳目一新。随着剧情不断展开，让大家了解北京建城传说，对北京文化产生兴趣，感受浓浓的北京味儿。",
      "老舍茶馆落户开封，国茶点亮美好生活、鲜花绽放，一片喜气洋洋，国家文化产业示范基地——老舍茶馆落户开封暨老舍茶馆开封店首届茶文化节盛典活动在这里隆重举行。中国茶叶流通协会副秘书长肖星，开封市委宣传部原副部长、著名书法家武占...",
    ],
  },
  partyBuildingNews: {
    tab: "党建新闻",
    title: [
      "中联部礼宾局副局长张露率队到大碗茶公司交流党建工作",
      "茶香飘两会 情暖值守人 李婕书记为大碗茶老舍茶馆送锦旗和慰问品",
      "大碗茶公司召开党支部书记述职评议会议",
      "知时节 | 小暑：夏日消暑大作战",
      "前门总店 | 暑期倾情奉献，传奇正在上演 — 儿童剧《八臂哪咤城》",
      "大碗茶公司党支部召开学习“蔡奇主持召开市委十二届八次全会，认...",
    ],
    content: [
      "应北京市大碗茶文化发展有限公司党支部之邀，2019年5月24日上午，中联部礼宾局副局长张露率中联部礼宾局一处党小组一行8人到大碗茶公司老舍茶馆交流党建工作。大碗茶公司党支部支委、高层管理人员、公司党员和入党积极分子参加座谈。活动由大碗茶公司党办主任顾德茂主持。活动伊始，张露局长一行参观了老舍茶馆店内...",
      "2019年4月19日上午，西城区委大栅栏街道工委书记李婕，副书记吴建华、范鹏一行来到大碗茶老舍茶馆赠送锦旗“茶香飘两会情暖值守人”和慰问品，代表大栅栏街道工委对大碗茶老舍茶馆在2019全国“两会”期间为大栅栏地区执勤点志愿者义务送水表示感谢。李婕书记在讲话中说，2019全国“两会”期间，大碗茶老舍茶馆团队...",
      "2019年3月5日上午，大碗茶公司党支部书记述职评议会议在四层会议室召开，西城区国资委党建科科长苏郁颖、干部李向阳，北京市大碗茶文化发展有限公司党支部书记、董事长、总经理尹智君出席，公司领导班子全体成员、党员、入党积极分子、中高层管理人员和基层员工代表参加会议。会议由大碗茶公司党办主任顾德茂主持，祝愿茶友们能够牛气冲天...",
      "倏忽温风至，因循小暑来小暑，六月节，是夏天的第五个节气，表示季夏时节的正式开始。虽说还没到最热，但是“小暑过，一日热三分”。炎炎夏日，即将开启蒸煮模式，老舍茶馆为您解锁避暑妙招。小暑品茶小暑，在室外喷火的天气里，品一杯寿眉白茶，味温性凉，有健胃提神之效，祛湿退热之功。衬托小暑的节气，...",
      "故事源于老北京的民间传说和你我的日常生活，通过展现亘古不变的亲情友情和瞬息万变的都市人情，最终实现城市与人共同的成长。演出将京味文化与魔幻现实主义结合，多样的舞台呈现让人耳目一新。随着剧情不断展开，让大家了解北京建城传说，对北京文化产生兴趣，感受浓浓的北京味儿。",
      "2019年2月20日下午，北京市大碗茶文化发展有限公司党支部召开传达学习“蔡奇主持召开市委十二届八次全会，认真学习贯彻习近平总书记视察北京重要讲话精神”专题座谈会。北京市大碗茶文化发展有限公司党支部书记、董事长、总经理，北京老舍茶馆有限公司董事长、总经理尹智君出席。公司党支部党员、入党积极分子和中国茶叶流通协会副秘书长肖星，开封市委宣传部原副部长、著名书法家武占...",
    ],
  },
  headOfState: {
    tab: "百名元首",
    title: "“一带一路”贵宾 老挝人革党中央政治局委员坎潘•蓬玛塔莅临老舍茶馆",
    content:
      "10月10日晚，布基纳法索争取进步人民运动党代理主席西蒙·孔波雷一行做客老舍茶馆品特色美食、欣赏京味儿演出、领略中国文化。“来了您呐，里边请……”步入老舍茶馆，西蒙·孔波雷主席即被浓郁的京味儿文化元素所吸引，并在大碗茶琴前驻足。在聆听了一整首中国民歌《茉莉花》后，西蒙·孔波雷主席连连鼓掌。在工作人员引...活动伊始，张露局长一行参观了老舍茶馆店内",
  },
  publicWlfareActivities: {
    tab: "公益活动",
    title: "西城区人大代表 大碗茶公司党支部书记尹智君慰问社区困难党员群众",
    content:
      "2019年1月31日下午，新春慰问困难户，浓浓关怀暖人心。己亥猪年春节将至，西城区人大代表、北京市大碗茶文化发展有限公司党支部书记、董事长、总经理，北京老舍茶馆有限公司董事长、总经理尹智君与大栅栏街道人大办主任孔祥博、前西社区服务站站长张葳一起到前西社区困难党员群众家庭走访慰问，送去慰问金和生活用品。",
  },
  teaParty: {
    tab: "小饮茶会",
    title: [
      "回顾「小饮茶会第229期」小饮茶会之名家内画鼻烟壶赏析",
      "回顾「小饮茶会第228期」小饮茶会之为您讲授冬月高效能读书心法",
    ],
    content: [
      "壶里看乾坤，方寸有意境。近日，由北京市文物公司策划的“凝烟撷萃——北京市文物公司藏内画鼻烟壶”展览在琉璃厂虹光阁开幕。展览展出了包括“京派内画四大家”在内的百余件清末民国时期的内画鼻烟壶名家大师作品。2019年1月11日，老舍茶馆小饮茶会带领茶友们走进北京市文物公司虹光阁探知名家内画鼻烟壶的魅力。",
      "书中自有黄金屋，书中自有颜如玉。读书的好处是说不尽的，但读书需要有正确的方法。2019年1月4日，小饮茶会邀请北京重点中学优秀教师、冬月高效能阅读心法创始人王冬月老师与大家分享“冬月高效能读书心法”。北京老舍茶馆有限公司常务副总经理唐波与十余位茶友参加。",
    ],
  },
};

export const characteristics = {
  title: ["演出大厅", "品珍楼", "四合茶院", "茶庄"],
  hall: [
    "❂ 演出大厅（三层）",
    "演出大厅总面积525平米，舞台面积约70平米，舞台进深7米，拥有LED大屏幕以及专业的电脑灯光和音响设备。",
    "大厅可容纳322人，同时也能满足举办展览展示，教育培训、婚宴、年会、寿宴、综艺演出和其它艺术活动与演出的需求。\n",
    "京味综艺演出《四季北京.茶》\n\n",
    "演出时间：每天20:00-21:10",
    "票价：100元、200元、300元、400元、500元/位",
    "演出项目介绍：",
    "京味综艺《四季北京.茶》，通过四季节气变化，将演出内容与北京生活场景相结合，在三十年上万场次演出经验基础上，结合现代科技手段、融合京味传统文化倾力打造。演出涵盖：京剧、鼓曲、杂技、魔术、口技、手影戏、北京京跤、中国功夫等传统文化内容，累计接待国内外观众百万人次，曾被列为北京市首批重点推介旅游演出项目。",
    "捧一盏香茗，观一场演出，感受一座北京城，使您在愉悦的夜晚流连中，留下一段难忘的记忆！\n",
    "相声汇演\n\n",
    "演出时间：每周周一至周五 下午16:00-18:00",
    "周六至周日 下午14:00-15:30星夜相声会馆团队",
    "周六至周日 下午16:30-18:00 老舍茶馆相声团队",
    "票价：80元、120元、180元、220元/位\n\n",
    "（若有临时变更以实际演出为准）\n\n",
    "场地租赁：8000元起；",
    "包场（含定制化演出服务）32000元起；",
    "婚宴活动费用：",
    "桌餐餐标：3999元/桌，5999元/桌。12桌起订，最高可预订22桌。无场租费。\n",
    "咨询预定电话：010-63036830\n\n",
    "\n❂ 艺苑(二层)",
    "艺苑采用王府戏楼风格设计，剧场总面积230平米，舞台长8.6m，拥有投影仪、幕布及专业的电脑灯光和音响设备，可容纳90位客人用餐，观看演出。可举办：喜寿堂会，小型会议等。\n",
    "老舍茶馆&宣南书馆评书专场\n\n",
    "演出时间：每周六 下午14：00—16:00",
    "票价：80元、120元/位\n\n",
    "北京曲艺团“京味相声”专场\n\n",
    "演出时间每周日：12:30-14:00",
    "票价：80元、120元、160元 、200元/位\n\n",
    "北京曲艺团“京味鼓曲”专场\n\n",
    "演出时间每周日：14:30-16:30",
    "票价：80元、120元、160元 、200元/位",
    "（若有临时变更以实际演出为准）\n\n",
    "场地租赁：6000元起；",
    "包场（含定制化演出服务）20000元起；",
    "婚宴活动费用：桌餐餐标：3999元/桌，5999元/桌。6桌起订，最高可预订10桌。无场租费。\n",
    "咨询预定电话：010-63036830\n\n",
  ],
  building: [
    "❂ 品珍楼（三层）",
    "品珍楼汇中华美食文化与千年茶文化，将传统饮食与中国茶文化相融合，集古今中外烹饪方法之大成，延皇家用膳之礼制，以海纳百川之亲和，展400年满汉筵席之精粹、百年古茶之韵味和自研茶餐、茶宴之清雅。品珍楼内设有“四季平安”“吉祥”“如意”“金玉满堂”“风调雨顺”五个包间。",
    "营业时间：11:00-14:00 17:00-20:00",
    "接待人数：56人",
    "经营特色：宫廷茶膳、小满汉全席\n\n",
    "风调雨顺：可容纳8人",
    "金玉满堂：可容纳8人",
    "吉祥：可容纳10-12人",
    "如意：可容纳10-12人",
    "四季平安：可容纳16人以内",
    "演出时间：每周周一至周五 下午16:00-18:00",
    "预定电话：010-63036830",
  ],
  yard: [
    "❂ 四合茶院（二层）",
    "四合茶院是以老北京的经典建筑形式四合院为原型建造的，集合了北方四合院和南方亭台楼阁的双重特点，共9个包间和1个散台，可容纳60位客人，特别适合商务会谈、朋友小聚。同时也能满足举办茶会、教育培训和其它艺术活动与演出的需求。\n",
    "营业时间：10:00-22:00",
    "接待人数：共9个包间，1个散台。\n\n",
    "经营特色：四合茶院式包间，经典茶事服务，可提供简餐、现场古筝演奏、茶艺表演、茶艺培训。",
    "茶院活动费用：空场地6000元起，含迎宾茶。",
    "预定电话：010-63036506\n\n",
  ],
  teaShop: [
    "❂ 茶庄（二层）",
    "茶庄—京味文化产品服务体验售卖区：它集皇家、文人雅士、市井百姓为代表的老北京饮茶方式于一体，采用开放式茶席、柜台和展柜，售卖有北京特色和茶馆特点的标志性商品，如品牌茶具、茶礼品、民俗工艺品、旅游纪念品、老北京特色食品，以商品为媒介，体现和传播北京文化形象。\n",
    "营业时间：10:00-22:00\n\n",
    "经营特色：中国六大茶类精品茶礼，自有品牌茶叶、茶具、茶点。",
    "服务专线：010-83150616\n\n",
  ],
};

export const stores = {
  title: ["华北地区", "华中地区", "华东地区", "西北地区"],
  north: {
    name: [
      "北京老舍茶馆前门店（总店）",
      "北京老舍茶馆大屯店",
      "北京大兴国际机场航站楼店",
    ],
    address: [
      "地址：北京市西城区前门西大街正阳市场三号楼老舍茶馆",
      "地址：北京市朝阳区亚运村大屯北路金泉美食宫F栋一层",
      "地址：北京大兴国际机场航站楼S-AR05-001",
    ],
    phone: [
      "电话：010-63036830/010-63021717\n\n",
      "电话：010-84874186\n\n",
      "电话：010-53383710",
    ],
  },
  central: {
    name: [
      "河南开封老舍茶馆960文化创意园",
      "湖北武汉老舍茶馆万达公馆店",
      "湖北武昌老舍茶馆万达御湖世家店",
      "湖北房县西关印象鹿鸣广场店",
      "湖南长沙黄花国际机场T2航站楼店",
    ],
    address: [
      "地址：河南开封960创意园区A3、A4栋（龙亭公园广场东侧）",
      "地址：武汉市武昌区积玉桥前进路万达公馆D06-D09",
      "地址：湖北武昌区中北路171号万达御湖世家2号门旁",
      "地址：湖北房县西关印象鹿鸣广场对面",
      "地址：湖南长沙黄花国际机场T2航站楼负一楼",
    ],
    phone: [
      "电话：0371-23339678/23331678\n\n",
      "电话：027-88111118/13986091992\n\n",
      "电话：027-87116686\n\n",
      "电话：0719-3222333\n\n",
      "电话：13975855413",
    ],
  },
  east: {
    name: [
      "山东济南老舍茶馆汉峪金谷店",
      "山东泰安老舍茶馆金融中心店",
      "山东青岛老舍茶馆海龙路店",
      "山东泰安老舍茶馆老街店",
      "安徽蚌埠老舍茶馆龙子湖店",
      "浙江义乌老舍茶馆店",
    ],
    address: [
      "地址：济南市历城区汉峪金谷A3-1栋",
      "地址：易初莲花南·泰山国际金融中心A座1-3层",
      "地址：青岛市崂山区海龙路1-1号老舍茶馆",
      "地址：泰安老街6号商业楼",
      "地址：安徽省蚌埠市环湖西路龙湖新天地商业广场B1栋",
      "地址：浙江省金华市义乌市北苑街道秀禾问茶A8",
    ],
    phone: [
      "电话：0531-55585196/55585197\n\n",
      "电话：（订餐）0538-5881708/709\n（品茗）0538-5881707\n\n",
      "电话：0532-88979588\n\n",
      "电话：0538-5881707\n\n",
      "电话：0552-3736000\n\n",
      "电话：0579-85069999",
    ],
  },
  northwest: {
    name: "陕西西安老舍茶馆西咸新区诗经里店",
    address: "地址：陕西省西安市长安区斗门街道沣东新城沣滨水镇诗经里19号楼",
    phone: "电话：029-89599859/89599459",
  },
};

export const contactUs = {
  title: ["场地定制服务", "联系方式"],
  service: [
    "老舍茶馆始建于1988年，位于天安门广场西南面，毗邻前门、大栅栏古商业街。现营业面积5000多平方米。包含茶事服务、文化演出、特色餐饮和茶礼品等四大经营业态，已累计接待170余位外国元首政要和500多万中外宾客。\n",
    "\n❂ 演出大厅（三层）\n\n",
    "演出大厅总面积525平米，舞台面积约70平米，舞台进深7米，拥有LED大屏幕以及专业的电脑灯光和音响设备。\n",
    "大厅可容纳322人，同时也能满足举办展览展示，教育培训、婚宴、年会、寿宴、综艺演出和其它艺术活动与演出的需求。\n",
    "演出大厅活动费用：空场地8000元起，包场（含演出）30000元起。提供盖碗茶。用餐1980元/桌起。\n",
    "\n❂ 艺苑（二层）\n\n",
    "艺苑采用王府戏楼风格设计，剧场总面积230平米，舞台长8.6m，拥有投影仪、幕布及专业的电脑灯光和音响设备，可容纳90位客人用餐，观看演出。可举办：喜寿堂会，小型会议等。\n",
    "艺苑活动费用：空场地6000元起，包场（含演出）25000元起，提供盖碗茶。用餐2200元/桌起。\n",
    "\n❂ 四合茶院（二层）\n\n",
    "茶院以老北京的经典建筑形式四合院为原型建造的，集合了北方四合院和南方亭台楼阁的双重特点，共9个包间和1个散台，可容纳60位客人，特别适合商务会谈、朋友小聚。同时也能满足举办茶会，教育培训、和其它艺术活动与演出的需求。\n",
    "茶院活动费用：空场地6000元起，含迎宾茶。\n\n",
  ],
  contact: {
    name: "北京前门老舍茶馆总店",
    phone: [
      "官方咨询电话： 010-63036830",
      "陈女士：15810413927",
      "宋先生：13611373487",
      "罗女士：15801690952\n\n",
    ],
    address: "地址：北京市西城区前门西大街正阳市场3号楼",
  },
};
